@if (inputForm) {
  <ng-container *transloco="let t">
    <div class="modal-body">
      <div class="d-flex align-items-center pb-4">
        <img src="assets/img/svg/T.svg" alt="Tracey logo">
        <div class="d-flex align-items-start flex-grow-1">
          <div class="fw-semibold title-wrapper line-height-1">
            {{ t("race.registration.settings.customField.add") }}
          </div>
        </div>
        <div class="pe-20 align-self-start">
          <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()">
          </button>
        </div>
      </div>
      <div class="body-wrapper">
        <form [formGroup]="inputForm">
          <div class="row">
            <div class="form-floating col-12 col-xxl-6">
              <app-language-input [inputForm]="inputForm" [defaultLanguage]="event?.defaultLanguage"
                                  [required]="true"
                                  [extraLanguages]="event?.extraLanguages" [hrKey]="'name'" [enKey]="'nameEng'"
                                  [itKey]="'nameIta'" [srKey]="'nameSr'" [bsKey]="'nameBs'"
                                  [siKey]="'nameSlo'" [hrLabel]="'race.registration.settings.customField.name'"
                                  [enLabel]="'race.registration.settings.customField.name.en'"
                                  [itLabel]="'race.registration.settings.customField.name.it'"
                                  [bsLabel]="'race.registration.settings.customField.name.bs'"
                                  [srLabel]="'race.registration.settings.customField.name.sr'"
                                  [siLabel]="'race.registration.settings.customField.name.sl'"/>
            </div>
            <div class="col-12 col-xxl-6 pb-0">
              <app-select formControlName="fieldConfigTypeId"
                          [items]="fieldConfigTypes" [valueKey]="'id'" [labelKey]="'id'"
                          [labelKeyPrefix]="'race.registration.settings.customField.type.'"
                          label="race.registration.settings.customField.type"/>
            </div>
          </div>
          <div class="row align-items-end">
            <div class="col-12 pt-xxl-2 mt-3 pb-0">
              <app-language-input [inputForm]="inputForm" [defaultLanguage]="event?.defaultLanguage"
                                  [required]="false"
                                  [extraLanguages]="event?.extraLanguages" [hrKey]="'info'" [enKey]="'infoEng'"
                                  [itKey]="'infoIta'" [srKey]="'infoSr'" [bsKey]="'infoBs'"
                                  [siKey]="'infoSlo'" [hrLabel]="'race.registration.settings.comment.placeholder'"
                                  [enLabel]="'race.registration.settings.comment.placeholder.en'"
                                  [itLabel]="'race.registration.settings.comment.placeholder.it'"
                                  [srLabel]="'race.registration.settings.comment.placeholder.sr'"
                                  [bsLabel]="'race.registration.settings.comment.placeholder.bs'"
                                  [siLabel]="'race.registration.settings.comment.placeholder.sl'"/>
            </div>
          </div>
          <div class="row pb-3 pt-3">
            @switch (inputForm.controls.fieldConfigTypeId.value) {
              @case (FieldConfigType.NUMBER) {
                <ng-container>
                  <div class="col-12 col-xl-6">
                    <app-input type="number" formControlName="minValue" placeholder="race.registration.settings.customField.minValue"
                               label="race.registration.settings.customField.minValue"/>
                  </div>
                  <div class="col-12 col-xl-6 pt-xl-0 pt-3">
                    <app-input type="number" formControlName="maxValue" placeholder="race.registration.settings.customField.maxValue"
                               label="race.registration.settings.customField.maxValue"/>
                  </div>
                </ng-container>
              }
              @case (FieldConfigType.TEXT) {
                <ng-container>
                  <div class="col-12 col-xl-6">
                    <app-input type="number" formControlName="minTextLength" placeholder="race.registration.settings.customField.minLength"
                               label="race.registration.settings.customField.minLength"/>
                  </div>
                  <div class="col-12 col-xl-6 pt-xl-0 pt-3">
                    <app-input type="number" formControlName="maxTextLength" placeholder="race.registration.settings.customField.maxLength"
                               label="race.registration.settings.customField.maxLength"/>
                  </div>
                </ng-container>
              }
              @case (FieldConfigType.SELECT) {
                <ng-template [ngTemplateOutlet]="select"></ng-template>
              }
              @case (FieldConfigType.MULTISELECT) {
                <ng-template [ngTemplateOutlet]="select"></ng-template>
              }
            }
          </div>

          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group pb-3">
                <label class="d-block fw-bold pb-2">{{
                    t("race.registration.settings.registrationDisplayFlags")
                  }}</label>
                @for (flag of registrationDisplayFlags;track flag) {
                  <div class="form-check">
                    <label class="form-check-label">
                      <input type="radio" class="form-check-input" name="registrationDisplayFlag" [value]="flag.id"
                             formControlName="registrationDisplayFlag">
                      {{ t("race.registration.settings.registrationDisplayFlags." + flag.id) }}
                    </label>
                  </div>
                }
              </div>
              <div class="form-group pb-3">
                <div class="form-check form-switch pt-3">
                  <input class="form-check-input" type="checkbox" id="licenceRequired" formControlName="required">
                  <label class="form-check-label text-muted" style="scale: 0.85;" for="licenceRequired">
                    {{ t("race.registration.settings.required") }}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group pb-3">
                <label class="d-block fw-bold pb-2">{{
                    t("race.registration.settings.visibility")
                  }}</label>
                @for (visibility of visibilityTypes;track visibility) {
                  <div class="form-check">
                    <label class="form-check-label">
                      <input type="radio" class="form-check-input" name="visibility" [value]="visibility.id"
                             formControlName="visibility">
                      {{ t("race.settings.visibilityTypes." + visibility.id) }}
                    </label>
                  </div>
                }
              </div>
            </div>
          </div>
          <ng-template #select>
            <div>
              <div class="pb-3 pt-2">
                <div class="d-flex align-items-center justify-content-between">
                        <span class="fw-bold text-uppercase">{{ t("race.registration.settings.customField.options") }}
                        </span>
                  <app-rounded-button [label]="t('race.registration.settings.customField.options.add')"
                                      (onClick)="onAddOption()"
                                      [btnClass]="'rounded-button--solid'"><i
                    class="bi bi-plus-circle pe-2"></i></app-rounded-button>
                </div>
              </div>
              <ng-container formArrayName="options">
                @if (options.controls.length ?? 0 > 0) {
                  <ul class="px-0 optionsHolder" id="optionsHolder">
                    <li *ngFor="let option of options.controls; let i = index" #options [@itemAnimation]="option">
                      <ng-container [formGroupName]="i">
                        <div class="d-flex justify-content-center align-items-end pb-3" [ngClass]="{'pt-2': i===0}">
                          <div class="col-11">
                            <app-language-input [inputForm]="optionFormControl(i)"
                                                [defaultLanguage]="event?.defaultLanguage" [required]="true"
                                                [extraLanguages]="event?.extraLanguages" [hrKey]="'name'"
                                                [enKey]="'nameEng'"
                                                [itKey]="'nameIta'" [siKey]="'nameSlo'" [srKey]="'nameSr'" [bsKey]="'nameBs'"
                                                [hrLabel]="'race.registration.settings.customField.option.name'"
                                                [enLabel]="'race.registration.settings.customField.option.name.en'"
                                                [itLabel]="'race.registration.settings.customField.option.name.it'"
                                                [bsLabel]="'race.registration.settings.customField.option.name.bs'"
                                                [srLabel]="'race.registration.settings.customField.option.name.sr'"
                                                [siLabel]="'race.registration.settings.customField.option.name.sl'"/>
                          </div>
                          <div class="col-1 ps-1 d-flex justify-content-center">
                                <span class="delete-icon" (click)="removeFieldConfigOption(i)"><i
                                  class="bi bi-trash-fill"></i></span>
                          </div>
                        </div>
                      </ng-container>
                    </li>
                  </ul>
                }
              </ng-container>
            </div>
          </ng-template>
        </form>
      </div>
      <div class="d-flex justify-content-center align-items-center pb-40-48">
        @if (customField) {
          <div class="me-3">
            <app-rounded-button [label]="t('app.common.delete')"
                                [btnClass]="'rounded-button--black-outline'" (onClick)="onDelete()"/>
          </div>
        }
        <app-rounded-button [label]="customField ? t('app.common.save') : t('app.common.add')" (onClick)="onSave()"
                            [btnClass]="'rounded-button--solid'"></app-rounded-button>
      </div>
    </div>
  </ng-container>
}

